import * as ActionTypes from '../constants/ActionTypes'
import * as Config from '../config/Config'

// **************************************************************************************************************
export const domainCheckReducer = (state = {
    domainInput: '',
    queriedDomain: '',
    queriedDomainEnding: '',
    furtherDomainLimit: 5,
    topLevelDomains: {
        data: {}, order: []
    },
    domainsAvailable: {},
    domainsGone: {},
    domainsLoading: {},
    domainsGettingAddedToCart: [],
    domainsGettingRemovedFromCart: [],
    hideDomainsGone: false
}, action) => {

    state = Object.assign({}, state)

    switch (action.type) {

        case ActionTypes.DOMAIN_INPUT_CHANGE:
            return Object.assign({}, state, {domainInput: action.value})

        case ActionTypes.TOPLEVELDOMAINS_SUCCESS:
            if (action.response && action.response.entities) {
                return Object.assign({}, state, {
                    topLevelDomains: {
                        data: action.response.entities.topLevelDomains,
                        order: action.response.result
                    }
                })
            }
            return state

        case ActionTypes.DOMAIN_CHECK_BEGIN:

            state = Object.assign({}, state)

            // modify input value
            if (state.domainInput.substr(0, 7) === 'http://') {
                state.domainInput = state.domainInput.substr(7)
            }
            if (state.domainInput.substr(0, 4) === 'www.') {
                state.domainInput = state.domainInput.substr(4)
            }

            state.domainInput = state.domainInput.toLowerCase();

            const domainRegEx = /^([äÄöÖüÜöÖßa-zA-Z0-9][äÄöÖüÜöÖßa-zA-Z0-9-_]{1,61}[äÄöÖüÜöÖßa-zA-Z0-9]{0,1})(\.){0,1}([a-zA-Z]{0,7}|[a-zA-Z0-9]{1,30}\.[a-zA-Z]{2,3})$/g
            const match = domainRegEx.exec(state.domainInput)

            // is valid domain?
            if (match && match.length > 0) {
                // alter domaininput with same regex
                state.domainInput = match[0]
                // grab domain title
                state.queriedDomain = match[1]
                // reset limit
                state.furtherDomainLimit = 5
                // grab domain ending
                if (match.length > 2) {
                    state.queriedDomainEnding = match[3]
                } else {
                    state.queriedDomainEnding = ""
                }
            }

            return state

        case ActionTypes.DOMAIN_LOAD_MORE:

            state = Object.assign({}, state)
            state.furtherDomainLimit += Config.DOMAIN_LOAD_MORE_AMOUNT

            return state

        case ActionTypes.DOMAIN_CHECK_REQUEST:

            state = Object.assign({}, state)

            if (!state.domainsLoading[action.payload.domainName]) {
                state.domainsLoading[action.payload.domainName] = []
            }
            if (state.domainsLoading[action.payload.domainName].indexOf(action.payload.domainEnding) === -1) {
                state.domainsLoading[action.payload.domainName] = [...state.domainsLoading[action.payload.domainName], action.payload.domainEnding]
            }

            return state

        case ActionTypes.DOMAIN_CHECK_FAILURE:
        case ActionTypes.DOMAIN_CHECK_SUCCESS:

            state = Object.assign({}, state)
            // deep copy
            state.domainsGone = Object.assign({}, state.domainsGone)
            state.domainsAvailable = Object.assign({}, state.domainsAvailable)
            state.domainsLoading = Object.assign({}, state.domainsLoading)

            const indexLoading = state.domainsLoading[action.payload.domainName].indexOf(action.payload.domainEnding)

            // remove from loading
            if (indexLoading !== -1) {
                state.domainsLoading[action.payload.domainName] = [...state.domainsLoading[action.payload.domainName].slice(0, indexLoading), ...state.domainsLoading[action.payload.domainName].slice(indexLoading + 1)]
            }


            if (action.response === 200) {

                if (!state.domainsAvailable[action.payload.domainName]) {
                    state.domainsAvailable[action.payload.domainName] = []
                }

                state.domainsAvailable[action.payload.domainName].push(action.payload.domainEnding)

            } else if ([410, 422].includes(action.status)) {

                if (!state.domainsGone[action.payload.domainName]) {
                    state.domainsGone[action.payload.domainName] = []
                }

                state.domainsGone[action.payload.domainName].push(action.payload.domainEnding)

            }

            return state

        case ActionTypes.CART_ADD_DOMAIN_REQUEST:

            state = Object.assign({}, state)

            if (action.payload.domain && state.domainsGettingAddedToCart.indexOf(action.payload.domain) === -1) {
                // add domain to pending domains if not in it yet
                state.domainsGettingAddedToCart = [...state.domainsGettingAddedToCart, action.payload.domain]
            }

            return state

        case ActionTypes.CART_ADD_DOMAIN_SUCCESS:
        case ActionTypes.CART_ADD_DOMAIN_FAILURE:

            state = Object.assign({}, state)

            const indexDomainToCart = state.domainsGettingAddedToCart.indexOf(action.payload.domain)

            // remove from loading
            if (indexDomainToCart !== -1) {
                state.domainsGettingAddedToCart = [...state.domainsGettingAddedToCart.slice(0, indexDomainToCart), ...state.domainsGettingAddedToCart.slice(indexDomainToCart + 1)]
            }

            return state


        case ActionTypes.CART_REMOVE_ITEM_REQUEST:


            if (action.payload.itemType === 'DOMAIN') {

                state = Object.assign({}, state)

                if (action.payload.itemId && state.domainsGettingRemovedFromCart.indexOf(action.payload.itemId) === -1) {
                    // add domain to pending domains if not in it yet
                    state.domainsGettingRemovedFromCart = [...state.domainsGettingRemovedFromCart, action.payload.itemId]
                }
            }

            return state

        case ActionTypes.CART_REMOVE_ITEM_SUCCESS:
        case ActionTypes.CART_REMOVE_ITEM_FAILURE:

            state = Object.assign({}, state)

            const indexItemToCart = state.domainsGettingRemovedFromCart.indexOf(action.payload.itemId)

            // remove from loading
            if (indexItemToCart !== -1) {
                state.domainsGettingRemovedFromCart = [...state.domainsGettingRemovedFromCart.slice(0, indexItemToCart), ...state.domainsGettingRemovedFromCart.slice(indexItemToCart + 1)]
            }

            return state

        case ActionTypes.DOMAIN_HIDE_GONE:

            return Object.assign({}, state, {hideDomainsGone: !state.hideDomainsGone})

        default:

            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/DomainCheck.js
 **/